import { render } from "./SignText.vue?vue&type=template&id=7c07a7bf&scoped=true"
const script = {}

import "./SignText.vue?vue&type=style&index=0&id=7c07a7bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c07a7bf"]])

export default __exports__